import { TECHNOLOGY_REQUIRED_POSITION_IDS } from 'domain/shared/career';

const technologyRequiredCondition = {
  value: true,
  when: {
    $specializationId: {
      in: TECHNOLOGY_REQUIRED_POSITION_IDS.flatMap(positionId => [positionId, String(positionId)]),
    },
  },
};

export const createPositionSlotValidationSchema = {
  specializationId: {
    type: 'string',
    required: true,
  },
  technologyId: {
    type: 'string',
    required: technologyRequiredCondition,
  },
  competencyLevel: {
    type: 'string',
    required: false,
  },
  officeIds: {
    type: 'array',
    required: true,
    minSize: 1,
  },
  workerType: {
    type: 'string',
    required: true,
  },
  workRateType: {
    type: 'string',
    required: true,
  },
  businessFunctionId: {
    type: 'string',
    required: true,
  },
};

export const createPositionSlotWithProfileValidationSchema = {
  ...createPositionSlotValidationSchema,
  competencyLevel: {
    type: 'string',
    required: true,
  },
  positionProfileId: {
    type: 'string',
    required: true,
  },
};

export const updatePositionSlotValidationSchema = {
  workRateType: {
    type: 'string',
    required: true,
  },
  isMarkedForDeletion: {
    type: 'boolean',
    required: true,
  },
};

export const getCreatePositionSlotValidationSchema = () => Promise.resolve(createPositionSlotValidationSchema);

export const getUpdatePositionSlotValidationSchema = () => Promise.resolve(updatePositionSlotValidationSchema);
